import Script from 'next/script';
import injectFaqData from '../FrequentlyAskedQuestions/injectFaqData';

const faqs = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: injectFaqData([]).map(faq => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer
    }
  }))
});

export default function StructuredData() {
  return (
    <Script strategy="beforeInteractive" type="application/ld+json">
      {faqs}
    </Script>
  );
}
